import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-technical-error',
  templateUrl: './technical-error.component.html',
  styleUrls: ['./technical-error.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class TechnicalErrorComponent implements OnInit
{

  constructor() { }

  ngOnInit(): void
  {
  }

}
